import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { p as props, d as defaults } from './componentEl-33ff2aeb.js';
import PropTypes from 'prop-types';

/*
Generic component for Tooltip , to be used in the context of Tooltip Trigger
The hover event on this element will trigger the Tooltip Content to be displayed
*/

function Trigger(_ref) {
  let {
    componentEl: Component,
    className,
    children
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "children"]);

  let cssClasses = ['st_tooltip_trigger'];
  cssClasses = addClassNames(className, cssClasses);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}

Trigger.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps
};
Trigger.defaultProps = {
  componentEl: defaults,
  className: null
};

/*
Generic component for Tooltip Content, to be used in the context of Tooltip Content
Accepts `position` (which side of the Triggershould the content be place) and
`size` (dictates the size of the actual Content box, if any)
*/

function Content(_ref) {
  let {
    componentEl: Component,
    className,
    children,
    position,
    size
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "children", "position", "size"]);

  let cssClasses = ['st_tooltip_content', "st_tooltip_content--" + position, "st_tooltip_content--" + size];
  cssClasses = addClassNames(className, cssClasses);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}

Content.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** dictates the position of the tool tip content */
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** dictates the size of the tool tip content if any  */
  size: PropTypes.oneOf(['none', 'md', 'mlg', 'lg', 'xl'])
};
Content.defaultProps = {
  componentEl: 'div',
  className: null,
  position: 'top',
  size: 'none'
};

/*
Generic component for Tooltip
Accepts one Trigger and One Content
Does not do any state management! See Storybook for examples for state management
*/

function Tooltip(_ref) {
  let {
    componentEl: Component,
    className,
    children
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "children"]);

  let cssClasses = ['st_tooltip'];
  cssClasses = addClassNames(className, cssClasses);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}

Tooltip.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps
};
Tooltip.defaultProps = {
  componentEl: defaults,
  className: null
};
Tooltip.Trigger = Trigger;
Tooltip.Trigger.displayName = 'Tooltip.Trigger';
Tooltip.Content = Content;
Tooltip.Content.displayName = 'Tooltip.Content';

export default Tooltip;
